module.exports = __webpack_public_path__ + "static/designPatternsIntro3-7217434a57b025827c9f66350bd0b914.png";